module.exports = __webpack_public_path__ + "static/LGS-desktop-6f2b164d38fd038818a105c1aac7d0dc.png";